import React, { useEffect, useState } from 'react';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import './Sidebar.scss';
import { getPublicPath } from 'config/environment';
import Elements from './Elements/Elements';
import SocialLinks from './SocialLinks/SocialLinks';

interface SidebarProps {
    toggleSidebar: (isExpanded: boolean) => void;
    sidebarStatus: boolean;
}

export default function Sidebar({ toggleSidebar, sidebarStatus }: SidebarProps) {

    const path = getPublicPath();
    const logo = `${path}/assets/img/logo/logo_black_center.png`;

    // Estado para controlar si el Sidebar está expandido o retraído
    const [isExpanded, setIsExpanded] = useState(sidebarStatus);

    // Función para alternar entre expandido y retraído
    const handleSidebarToggle = () => {
        setIsExpanded(!isExpanded);
        toggleSidebar(!isExpanded);
    };

    // Cerrar el sidebar (overlay móvil)
    const handleSidebarClose = () => {
        if (!isExpanded) {
            return;
        }
        setIsExpanded(false);
        toggleSidebar(false);
    };

    useEffect(() => {
        const isOverlay = window.innerWidth <= 768;
        document.body.style.overflow = isExpanded && isOverlay ? 'hidden' : '';

        return () => {
            document.body.style.overflow = '';
        };
    }, [isExpanded]);

    return (
        <>
            {/* Blur detrás del sidebar en móvil cuando está desplegado */}
            {isExpanded && (
                <button
                    type="button"
                    className="sidebar-backdrop"
                    aria-label="Close sidebar"
                    onClick={handleSidebarClose}
                />
            )}

            <div className={`sidebar ${isExpanded ? 'expanded' : 'retracted'}`}>

                {/* Logo del sidebar */}
                <div className='container_logo'>
                    <img src={logo} alt="Logo" className="logo" />

                    <span translate="no" className='ocupation'>Full Stack</span>

                    <Tooltip text="Toggle Sidebar" position='right'>
                        <button onClick={handleSidebarToggle} className="toggle-btn">
                            {/* Cambia el ícono según el estado */}
                            {isExpanded ? <i className="fa-solid fa-bars"></i> : <i className="fa-solid fa-bars-sort"></i>}
                        </button>
                    </Tooltip>
                </div>

                <hr className='divisor'></hr>

                {/* Contenido del Sidebar */}
                <Elements isExpanded={isExpanded} />

                {/* Contenedor de redes sociales */}
                <SocialLinks isExpanded={isExpanded} />
            </div>
        </>
    );
}
